import { getQueryVariable } from '@/utils/common';

function isLinux_platform_func() {
    //平台、设备和操作系统
    let system = {
        win: false,
        mac: false,
        x11: false,
        ipad: false,
    };
    //检测平台
    let p = navigator.platform;
    system.win = p.indexOf('Win') == 0;
    system.mac = p.indexOf('Mac') == 0;
    system.x11 = p == 'X11' || p.indexOf('Linux') == 0;
    system.ipad = navigator.userAgent.match(/iPad/i) != null ? true : false;
    if (system.x11) {
        let u = navigator.userAgent;
        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
        if (isAndroid) {
            return false;
        }
    }
    return system.x11;
}
export function getPlatform() {
    /*
    PhantomOnline
    Phantom
    FoxitReader
    MacPhantom
  */
    let platform = '',
        asyncCall = false;
    do {
        platform = getQueryVariable('platform');
        if (
            (window.qt && window.qt.webChannelTransport) ||
            (window.webkit &&
                window.webkit.messageHandlers &&
                window.webkit.messageHandlers.DispatchFun &&
                window.webkit.messageHandlers.DispatchFun.postMessage)
        ) {
            asyncCall = true;
        }
        if (platform) {
            break;
        }
        if (
            window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.DispatchFun &&
            window.webkit.messageHandlers.DispatchFun.postMessage
        ) {
            asyncCall = true;
            platform = 'ios';
            break;
        }
        if (isLinux_platform_func()) {
            console.log('isLinux_platform_func');
            platform = 'Linux PDF Editor';
            break;
        }

        if (
            parent && //eslint-disable-line
            parent.window && //eslint-disable-line
            parent.window.platform === 'PhantomOnline' //eslint-disable-line
        ) {
            platform = 'PhantomOnline';
            break;
        }
        if (window.external && window.external.platform) {
            platform = window.external.platform;
            break;
        }
        if (window.external && window.external.getPlatform) {
            platform = window.external.getPlatform();
            break;
        }
        if (window.qt && window.qt.webChannelTransport) {
            asyncCall = true;
            platform = 'Lite';
            break;
        }
    } while (false);

    if (!platform) platform = 'Phantom';

    return { platform, asyncCall };
}

//eslint-disable-next-line
export function loadqwebchannel(cb) {
    loadScript('/qwebchannel.js', function () {
        //eslint-disable-next-line
        new QWebChannel(window.qt.webChannelTransport, function (channel) {
            window.external = channel.objects.external;
            cb && cb();
        });
    });
}

window.loadqwebchannel = loadqwebchannel;

export function loadScript(src, opts, cb) {
    //eslint-disable-next-line
    const stdOnEnd = (script, cb) => {
        script.onload = function () {
            this.onerror = this.onload = null;
            cb(null, script);
        };
        script.onerror = function () {
            // this.onload = null here is necessary
            // because even IE9 works not like others
            this.onerror = this.onload = null;
            cb(new Error('Failed to load ' + this.src), script);
        };
    };

    const ieOnEnd = (script, cb) => {
        script.onreadystatechange = function () {
            if (this.readyState != 'complete' && this.readyState != 'loaded')
                return;
            this.onreadystatechange = null;
            cb(null, script); // there is no way to catch loading errors in IE8
        };
    };
    const setAttributes = (script, attrs) => {
        for (let attr in attrs) {
            script.setAttribute(attr, attrs[attr]);
        }
    };

    let head = document.head || document.getElementsByTagName('head')[0];
    let script = document.createElement('script');

    if (typeof opts === 'function') {
        cb = opts;
        opts = {};
    }

    opts = opts || {};
    cb = cb || function () {};

    script.type = opts.type || 'text/javascript';
    script.charset = opts.charset || 'utf8';
    script.async = 'async' in opts ? !!opts.async : true;
    script.src = src;

    if (opts.attrs) {
        setAttributes(script, opts.attrs);
    }

    if (opts.text) {
        script.text = '' + opts.text;
    }

    let onend = 'onload' in script ? stdOnEnd : ieOnEnd;
    onend(script, cb);

    // some good legacy browsers (firefox) fail the 'in' detection above
    // so as a fallback we always set onload
    // old IE will ignore this and new IE will set onload
    if (!script.onload) {
        stdOnEnd(script, cb);
    }

    head.appendChild(script);
}
